"use client";

import React, { useRef } from "react";
import { useParallax } from "@/hooks/useParallax";
import styles from "./OurServices.module.scss";

const OurServices = () => {
	const servicesList1Ref = useRef<HTMLUListElement>(null);
	const servicesList2Ref = useRef<HTMLUListElement>(null);

	// Apply staggered parallax speeds for depth
	// First list - slower
	useParallax(servicesList1Ref, {
		speed: 0.7,
		direction: 'down',
		distance: 50,
		scrub: 1.5,
	});

	// Second list - faster for layering effect
	useParallax(servicesList2Ref, {
		speed: 1.2,
		direction: 'up',
		distance: 50,
		scrub: 1.5,
	});

	return (
		<section className={styles["our-services"]}>
			<div className={styles["our-offering"]}>
				<h2>Our Offering</h2>
				<div className={styles["our-offering__services"]}>
					<ul ref={servicesList1Ref}>
						<li>Logo Development</li>
						<li>Brand Strategy</li>
						<li>Corporate Identities</li>
						<li>Brand Guidelines</li>
						<li>Art Direction</li>
						<li>Illustration</li>
						<li>Typography</li>
					</ul>
					<ul ref={servicesList2Ref}>
						<li>UX Design</li>
						<li>Strategy</li>
						<li>UI Design</li>
						<li>Art Direction</li>
						<li>Interactive Prototyping</li>
						<li>Web Development</li>
						<li>App Development</li>
						<li>eCommerce Solutions</li>
					</ul>
				</div>
			</div>
			<div className={styles["our-approach"]}>
				<h2>Our Approach</h2>
				<div className={styles["our-approach__content"]}>
					<p>
						We don't have a house style or a signature aesthetic collecting dust in our portfolio. What we do have is an unwavering commitment to craft and a belief that every project deserves its own voice. Some experiences whisper. Others shout. We build for both, and everything in between.
						<br />
						<br /> Our process is deliberate but never rigid—multidisciplinary collaboration meets focused execution. We move fast, think deeply, and always aim for each project to outshine the last.
					</p>
				</div>
			</div>
		</section>
	);
};

export default OurServices;
